import log from "skin/auth/login";
import { useCallback, useState } from "react";

export default function useLogin() {
	const [wait, setWait] = useState(false);
	const [login, setLogin] = useState('');
	const [password, setPassword] = useState('');
	const [msg, setMsg] = useState({});
	const chMsg = (k, v) => setMsg(s => ({ ...s, [k]: v }));
	const onLoginChange = useCallback(e => {
		const value = e.target.value;
		setLogin(value);
		chMsg('login', null);
	}, []);
	const onPasswordChange = useCallback(e => {
		const value = e.target.value;
		setPassword(value);
		chMsg('password', null);
	}, []);

	const value = {};
	value.login = login;
	value.password = password;

	const handlers = {};
	handlers.login = onLoginChange;
	handlers.password = onPasswordChange;

	const submit = useCallback(() => {
		chMsg('query', null);
		if (!login || !password) {
			if (!login) chMsg('login', 'Введите логин');
			if (!password) chMsg('password', 'Введите пароль');
			return
		}
		setMsg({});
		setWait(true);
		log(login, password, v => {
			setWait(false);
			chMsg('query', v);
		});
	}, [login, password]);

	return { value, handlers, msg, wait, submit };
}